import React, { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import ConexContext from '../context/ConexContext';
import ModalLogin from './modales/ModalLogin';
import ModalSesionCerrada from './modales/ModalSesionCerrada';

export const Login = ({mensaje, setmensaje, mensaje2}) => {
	const [searchParams,setSearchParams] = useSearchParams();
	const [loginNormal, setLoginNormal] = useState(false);
	const [loginURL, setloginURL] = useState(false);
	const {getToken, setToken, peticion}=useContext(ConexContext);
	useEffect(()=>{
		async function descifrar(){
			let key = searchParams.get("FIRMA")
			let ent = searchParams.get("ent")
			if(!key || !ent){
				setLoginNormal(true);
				return;
			}
			//ESTO LO QUITO PORQUE FÉLIX QUIERE QUE SE AUTENTIFIQUE SI O SI SI HAY URL
			//if(getToken()) return      

			let res=await peticion(`/login_sec?cod_ent=${ent}`,{method:'GET', headers: {'key': key, 'cod_ent': ent }});
			if(res?.estado??true) return;
			if (!res["res"].auth){
				setloginURL(false)
				setmensaje(res["mensaje"])
			}else{
				setloginURL(true)
				setmensaje("")
				setToken(res["res"]["jwt"]);
				//ok ahora borro los get
				searchParams.delete('FIRMA')
				searchParams.delete('ent')
				setSearchParams(searchParams)
			}
		}
		if(loginNormal || loginURL) return;
		descifrar();
		// eslint-disable-next-line
	},[searchParams])
	
	if((loginNormal && !getToken())|| (!loginURL)) 
		return (
			<ModalLogin 
				mensaje={mensaje}
				setmensaje={setmensaje}
			/>
		)
	else
		if((loginURL && !getToken())) 
			return (
				<ModalSesionCerrada 
					mensaje2={mensaje2}
				/>
			)
	else
		return ("")	
}
